module.exports = __webpack_public_path__ + "static/media/oh-brother.156abde5.mp3";